import React from "react";
import { Route, Redirect, Switch } from "react-router";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

import PageWrapper from "components/PageWrapper";

import { linkToNewPhoto } from "./new/links";
import NewPhotoRoute from "./new/Route";

import { linkToCategorise } from "./categorise/links";
import CategorisePhotoRoute from "./categorise/Route";

import { linkToGeotag } from "./geotag/links";
import GeoTagPhotoRoute from "./geotag/Route";

import { linkToReportFunctionSelect } from "routes/report/links";
import ReportRoute from "routes/report/Route";
import config from "../../../custom/config";

export default function PhotoPageSubRouter() {
  const history = useHistory();
  const { t } = useTranslation();

  const navigationHandler = {
    handleBack: () => history.goBack(),
    confirm: true
  };

  return (
    <Switch>
      {/* TODO: tidy up when categorise route no longer required */}
      <Route path={linkToCategorise()}>
        <PageWrapper
          label={t(config.PAGES.photo.label)}
          navigationHandler={navigationHandler}
        >
          <CategorisePhotoRoute />
        </PageWrapper>
      </Route>
      <Route path={linkToGeotag()}>
        <PageWrapper
          label={t(config.PAGES.photo.label)}
          navigationHandler={navigationHandler}
        >
          <GeoTagPhotoRoute />
        </PageWrapper>
      </Route>
      <Route path={linkToNewPhoto()}>
        <PageWrapper
          label={t(config.PAGES.photo.label)}
          navigationHandler={navigationHandler}
        >
          <NewPhotoRoute />
        </PageWrapper>
      </Route>
      <Route path={linkToReportFunctionSelect()}>
        <ReportRoute />
      </Route>
      <Redirect to={linkToNewPhoto()} />
    </Switch>
  );
}
